import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { PremiereBillboard } from "../components/PremiereBillboard";
import { PremiereChat } from "../components/PremiereChat";
import { PhotoWall } from "../components/PhotoWall";

export default function Premiere() {
  const [pid, setPid] = useState(null);
  useEffect(() => {
    document.title = "GIG LIFE — Official Premiere · MY VELOCITY";
    api.get("/giglife").then((r) => setPid(r.data.premiere?.premiere_id || r.data.premiere_id || null)).catch(() => {});
    return () => { document.title = "MY VELOCITY"; };
  }, []);
  return (
    <main className="min-h-screen bg-[#05080f] text-slate-100" data-testid="premiere-page">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <div className="flex items-center justify-between mb-5">
          <Link to="/" className="inline-flex items-center gap-2 text-xs text-slate-400 hover:text-slate-200" data-testid="premiere-back"><ArrowLeft className="w-4 h-4" />MY VELOCITY</Link>
          <p className="text-[11px] font-mono uppercase tracking-[0.35em] text-blue-300">Velocity Films · Red carpet</p>
        </div>
        <div className="grid lg:grid-cols-[minmax(0,1fr)_340px] gap-6 items-stretch">
          <PremiereBillboard large fanQuotes />
          <PremiereChat premiereId={pid} />
        </div>
      </div>
      <div className="[&_section]:border-t-0 [&_h2]:text-slate-50 [&_p]:text-slate-400"><PhotoWall /></div>
    </main>
  );
}
